<div class="qui-form-layout__col-center flex flex-col gap-400">
  @if (allFieldsLocked()) {
    <app-locked-quote-alert></app-locked-quote-alert>
  }
  @if (isAutoAdvanceEnabled()) {
    <p class="sr-only">Selecting an option will immediately submit the form and take you to the next page. You cannot navigate backwards and change your selection.</p>
  }
  <form [formGroup]="foundationTypeForm" (ngSubmit)="handleSubmit($event)" id="quote-form">
    <app-form-card [title]="'What kind of foundation is your home built on?'" icon="lucideHouse" formDisplayAddress="{{ formDisplayAddress }}">
      <div class="mt-600 grid grid-cols-1 gap-x-6 gap-y-6 md:gap-y-10">
        <fieldset class="form-group__fieldset" [appReadonlyRadioGroup]="isFieldLocked('foundationType')" [appFocusOnlyRadioGroup]="isAutoAdvanceEnabled()">
          <legend class="sr-only">Select the foundation type</legend>
          <div class="grid gap-200 md:grid-cols-2">
            @for (foundationTypeOption of foundationTypeOptions; track foundationTypeOption) {
              <label
                class="radio-card radio-card--block group focus-within:ring-primary focus-within:ring-2"
                [class.radio-card--invalid]="hasError"
                [for]="foundationTypeOption.id"
                [attr.data-testid]="'foundation-option-' + foundationTypeOption.id"
              >
                <div class="radio-card__header flex flex-col gap-100">
                  <div class="flex w-full items-center justify-start">
                    <ng-icon [name]="foundationTypeOption.icon" size="30" class="radio-card__icon !overflow-visible text-black"></ng-icon>
                    <p class="radio-card__title m-l-200 font-medium group-has-[:checked]:font-bold">{{ foundationTypeOption.label }}</p>
                  </div>
                  <div class="w-full">
                    <p class="text-sm">{{ foundationTypeOption.description }}</p>
                  </div>
                </div>
                <input class="radio-card__control peer outline-none" type="radio" [id]="foundationTypeOption.value" [value]="foundationTypeOption.value" formControlName="foundationType" />
              </label>
            }
          </div>
        </fieldset>

        @if (hasError) {
          <div class="fs-body-md fw-medium error-message text-warning flex items-center gap-100" role="alert" data-testid="form-error-message" aria-live="polite" aria-atomic="true">
            <ng-icon name="lucideCircleAlert" size="16" class="!overflow-visible" aria-hidden="true"></ng-icon>
            Please select your home's foundation type.
          </div>
        }
      </div>
    </app-form-card>
  </form>

  <!-- @todo - make this its own info component -->
  <div class="rounded-200 bg-primary-300 px-500 py-300" data-testid="help-text">
    <div class="flex items-start gap-300">
      <ng-icon name="lucideCircleHelp" size="24" class="[&>svg]:fill-primary !overflow-visible" aria-hidden="true"></ng-icon>
      <div class="flex flex-col gap-300">
        <div>
          <p><strong>Not sure how to answer?</strong></p>
          <p class="hidden md:block">If you'd like a little extra help, our licensed agents are here for you.</p>
          <p class="md:hidden">One of our licensed agents will be happy to help.</p>
        </div>
        <div class="hidden md:block">
          <p class="font-bold">{{ salesPhoneNumber | phone }}</p>
          <p>{{ salesPhoneHoursFormatted }}</p>
        </div>
      </div>
    </div>

    <button (click)="contactDialogService.open()" data-testid="help-text-href" class="button button--sm button--secondary mt-300 w-full items-center justify-center gap-100 text-center md:hidden">
      <ng-icon name="lucidePhone" size="16" class="!overflow-visible" aria-hidden="true"></ng-icon>
      Talk to an agent
    </button>
  </div>
</div>
